<template>
  <div class="mdc-dialog" id="nextLessonDialog">
    <div class="mdc-dialog__container">
      <div class="mdc-dialog__surface">
        <h2 class="mdc-dialog__title" id="my-dialog-title">
          {{ $t("958") }}
          <!-- 레슨이 모두 끝났습니다! -->
        </h2>
        <div class="mdc-dialog__content" id="my-dialog-content">
          <div class="t-color-content1">
            {{ $t("959") }}
            <!-- 다음 레슨 -->
          </div>
          <div class="t-subtitle3">
            {{ nextLesson.name }}
          </div>
          <div class="circular-body t-headline3">
            <circular-count-down-timer
              :stroke-width="5"
              :underneath-stroke-color="'#FEDDDD'"
              :seconds-fill-color="'#FEDDDD'"
              :seconds-stroke-color="'#fc5356'"
              :initial-value="5"
              :steps="1"
              second-label=""
              :show-negatives="false"
              @finish="moveNextLesson(nextLesson)"
            ></circular-count-down-timer>
          </div>
        </div>
        <footer class="mdc-dialog__actions">
          <button
            type="button"
            class="mdc-button mdc-dialog__button btn-white"
            data-mdc-dialog-action="no"
            tabindex="-1"
            @click="moveLearnView()"
          >
            {{ $t("960") }}
            <!-- 나중에 하기 -->
          </button>
          <!-- <button type="button" class="mdc-button mdc-dialog__button btn-white" data-mdc-dialog-action="no" @click="moveNextLesson(nextLesson)">
                        {{$t('Todo-바로 학습하기')}}                    
                    </button> -->
        </footer>
      </div>
    </div>
    <div class="mdc-dialog__scrim"></div>
  </div>
</template>

<script>
/**
 * 나의 학습 차시 학습창 - 다음학습 팝업 컴포넌트(my learning lesson study - next lesson popup component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import { MDCDialog } from "@material/dialog";
import learnApi from "@/api/learnApi.js";

export default {
  props: ["nextLesson"],
  data() {
    return {
      nextLessonDialog: null,
    };
  },
  mounted() {
    // console.log('thumbnailVideo', this.thumbnailVideo)
    // console.log('type', this.type)
    this.nextLessonDialog = new MDCDialog(
      document.getElementById("nextLessonDialog")
    );
    this.nextLessonDialog.open();
    let learnId = this.$route.params.learnId;
    if (this.nextLesson) {
      let contentsType =
        this.nextLesson && this.nextLesson.contentsType
          ? this.nextLesson.contentsType.value
          : "";
      if (contentsType == "VIDEO") {
        let progressionId = this.nextLesson
          ? this.nextLesson.progressionId
          : "";
        let params = { learnId: learnId, progressionId: progressionId };
        learnApi
          .learnLessonContents(params)
          .then((response) => {
            this.thumbnails =
              response.data.data && response.data.data.video
                ? response.data.data.video.thumbnails[0]
                : null;
            //let getThumbnail = response.data.data
            //this.thumbnailVideo = getThumbnail.thumbnail
          })
          .catch((err) => {});
      }
    }
  },

  methods: {
    moveLearnView() {
      this.$emit("moveLearnView");
    },

    // 다음 학습으로 이동(move next lesson learning)
    moveNextLesson(lesson) {
      this.nextLessonDialog.close();
      let learnId = this.$route.params.learnId;
      let status = this.$route.query.status;
      console.log("lesson=>", lesson);
      //console.log('moveNextLesson=>',this.$router.push(`/learn/${learnId}/lessonContents/${lesson.progressionId}`))

      if (
        lesson &&
        lesson.contentsType &&
        lesson.contentsType.value == "VIDEO"
      ) {
        this.$router.push(
          `/learn/${learnId}/${lesson.id}/lessonContents/${lesson.progressionId}?status=` +
            status
        );
      } else if (
        lesson &&
        lesson.contentsType &&
        lesson.contentsType.value == "EXAM_PAPER"
      ) {
        this.$router.push(
          `/learn/${learnId}/lessonExam/${lesson.examineeId}/intro?status=` +
            status
        );
      } else if (
        lesson &&
        lesson.contentsType &&
        lesson.contentsType.value == "PDF"
      ) {
        this.$router.push(
          `/learn/${learnId}/${lesson.id}/lessonContents/${lesson.progressionId}?status=` +
            status
        );
      } else {
        this.$router.push(
          `/learn/${learnId}/${lesson.id}/lessonContents/${lesson.progressionId}?status=` +
            status
        );
      }
    },
  },
};
</script>